var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"0","height":"0","border":"0"},attrs:{"src":`${this.apiUrl}/portal/logout`,"id":"logoutFrame"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }